import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// Tambahkan 'deleteDoc' dan 'doc'
import { collection, onSnapshot, query, orderBy, deleteDoc, doc } from 'firebase/firestore'
import { db } from '../firebaseConfig'

export default function UsersPage() {
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('semua')
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [fadeState, setFadeState] = useState('fade-in')
  const itemsPerPage = 10

  // 🔥 Real-time listener Firestore
  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('name'))
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setUsers(data)
      setLoading(false)
    })
    return () => unsubscribe()
  }, [])

  // 🔍 Filter dan pencarian
  const filteredUsers = users.filter((u) => {
    const matchesFilter =
      filter === 'semua' || u.status?.toLowerCase() === filter
    const matchesSearch =
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase()) ||
      u.phone?.includes(search)
    return matchesFilter && matchesSearch
  })

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const currentUsers = filteredUsers.slice(
    startIndex,
    startIndex + itemsPerPage
  )

  // 🔙 Tombol kembali ke dashboard dengan efek fade-out
  const handleBack = () => {
    setFadeState('fade-out')
    setTimeout(() => navigate('/'), 300)
  }
  // 🗑️ Fungsi Hapus User
  const handleDelete = async (userId) => {
    if (window.confirm('⚠️ Apakah Anda yakin ingin menghapus user ini secara PERMANEN? Data yang dihapus tidak dapat dikembalikan.')) {
      try {
        await deleteDoc(doc(db, 'users', userId))
        alert('✅ User berhasil dihapus dari database.')
      } catch (error) {
        console.error('Gagal menghapus user:', error)
        alert('❌ Terjadi kesalahan saat menghapus user.')
      }
    }
  }

  return (
    <div
      className={`min-h-screen bg-gray-950 text-gray-200 p-6 transform transition-all duration-500 ${
        fadeState === 'fade-in'
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-2'
      }`}
      style={{ transitionProperty: 'opacity, transform' }}
    >
      {/* Tombol kembali ke dashboard */}
      <button
        onClick={handleBack}
        className="mb-6 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition"
      >
        ← Kembali ke Dashboard
      </button>

      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <h2 className="text-2xl font-bold">👥 Data Pengguna</h2>

        <div className="flex flex-wrap items-center gap-3">
          <input
            type="text"
            placeholder="Cari nama, email, atau no HP..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value)
              setCurrentPage(1)
            }}
            className="bg-gray-900 border border-gray-700 text-gray-300 px-3 py-2 rounded-lg text-sm w-64 focus:ring-2 focus:ring-blue-600 outline-none"
          />
          <select
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value)
              setCurrentPage(1)
            }}
            className="bg-gray-900 border border-gray-700 text-gray-300 px-3 py-2 rounded-lg text-sm"
          >
            <option value="semua">Semua</option>
            <option value="aktif">User Aktif</option>
            <option value="blokir">User Diblokir</option>
          </select>
        </div>
      </div>

      {/* Loading */}
      {loading ? (
        <div className="text-gray-400 text-center p-8">Memuat data...</div>
      ) : (
        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden shadow-lg">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-800 text-gray-100">
              <tr>
                <th className="p-3 text-left font-semibold">Nama</th>
                <th className="p-3 text-left font-semibold">Email</th>
                <th className="p-3 text-left font-semibold">Nomor Telepon</th>
                <th className="p-3 text-left font-semibold">
                  Tanggal Bergabung
                </th>
                <th className="p-3 text-left font-semibold">ID HP</th>
                <th className="p-3 text-left font-semibold">Status</th>
                <th className="p-3 text-center font-semibold">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.length > 0 ? (
                currentUsers.map((user) => (
                  <tr
                    key={user.id}
                    className="border-t border-gray-800 hover:bg-gray-800/60 transition"
                  >
                    <td className="p-3">{user.name}</td>
                    <td className="p-3">{user.email}</td>
                    <td className="p-3">{user.phone}</td>
                    <td className="p-3">{user.joinDate}</td>
                    <td className="p-3">{user.deviceId}</td>
                    <td className="p-3">
                      <span
                        className={`px-2 py-1 rounded-md text-xs font-semibold ${
                          user.status === 'aktif'
                            ? 'bg-green-700 text-white'
                            : 'bg-red-700 text-white'
                        }`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td className="p-3 text-center flex justify-center gap-2">
                      {/* Tombol Detail */}
                      <button
                        onClick={() => navigate(`/users/${user.id}`)}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg text-xs transition"
                      >
                        Detail
                      </button>

                      {/* Tombol Hapus (BARU) */}
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-lg text-xs transition"
                      >
                        Hapus
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center p-6 text-gray-400 italic"
                  >
                    Tidak ada data pengguna yang cocok.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-3 p-4 bg-gray-900 border-t border-gray-800">
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 disabled:opacity-50"
              >
                ←
              </button>
              <span className="text-gray-400 text-sm">
                Halaman {currentPage} dari {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="px-3 py-1 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 disabled:opacity-50"
              >
                →
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
